import { LoadingOverlay } from '@soteria/design-system-ve';
import type { PropsWithChildren, ReactNode } from 'react';

import { BaseLayout } from './BaseLayout';
import { mainContent, footerWrapper } from './Layout.css';
import { PageFooter } from './PageFooter';

/**
 * LoadingLayout props interface
 */
interface LoadingLayoutProps {
  /**
   * Optional loading message to display
   */
  message?: string;

  /**
   * Optional loading overlay content
   */
  loadingContent?: ReactNode;

  /**
   * Whether to show the layout structure behind the loading overlay
   */
  showLayoutBehind?: boolean;
}

/**
 * LoadingLayout component
 * Displays a loading overlay with optional message
 * Can optionally show the layout structure behind the loading overlay
 */
export function LoadingLayout({ message = 'Loading...', loadingContent, showLayoutBehind = false, children }: PropsWithChildren<LoadingLayoutProps>) {
  // If we don't want to show the layout behind, just show a full-screen loading overlay
  if (!showLayoutBehind) {
    return loadingContent || <LoadingOverlay fullScreen message={message} />;
  }

  // Otherwise, show the layout with a loading overlay on top
  return (
    <>
      <BaseLayout
        className={mainContent}
        footer={
          <div className={footerWrapper}>
            <PageFooter />
          </div>
        }
      >
        {children}
      </BaseLayout>
      {loadingContent || <LoadingOverlay fullScreen message={message} />}
    </>
  );
}
